import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import * as Objects from '@core/objects';

import { FieldDataInterface } from '@core/custom-forms/models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from "@core/custom-forms/models/settings/settings-custom-form-field-data.class";

export enum SettingsFormsActionsType {
    // PERSISTED FORMS ACTIONS
    // loadings
    LoadForms = "[SettingsForms] GET - Obtain all persisted forms",
	LoadFormsSuccess = "[SettingsForms] - Obtain all persisted forms SUCCESS",
	LoadFormsError = "[SettingsForms] - Obtain all persisted forms ERROR",

    LoadForm = "[SettingsForms] - GET load persisted form",
	LoadFormSuccess = "[SettingsForms] - Load persisted form SUCCESS",
	LoadFormError = "[SettingsForms] - Load persisted form ERROR",

    LoadFields = "[SettingsForms] - GET load persisted form fields of a form",
	LoadFieldsSuccess = "[SettingsForms] - Load persisted form fields of a form SUCCESS",
	LoadFieldsError = "[SettingsForms] - Load persisted form fields of a form ERROR",

    // sync
    SetFormName = "[SettingsForms] - set form name in editing form",
    SetFormDescription = "[SettingsForms] - set form description in editing form",
    
    AddField = "[SettingsForms] - add new field of type in editing form fields",
    SetField = "[SettingsForms] - set field in editing form fields as updated",
    MoveFieldUp = '[SettingsForms] - Move Field Up',
    MoveFieldDown = '[SettingsForms] - Move Field Down',
    UpdateFieldPositions = "[SettingsForms] Update given fields positions in the editing form",
    RemoveField = '[SettingsForms] - Remove Field from list - mark as not active',

    // save action
    SaveForm = "[SettingsForms] - Save or create current new form",
	SaveFormSuccess = "[SettingsForms] - Save current form SUCCESS",
	SaveFormError = "[SettingsForms] - Save current form ERROR",

    SaveFields = "[SettingsForms] POST - Save or create current fields",
	SaveFieldsSuccess = "[SettingsForms] - Save current fields SUCCESS",
	SaveFieldsError = "[SettingsForms] - Save current fields ERROR",

    // server calls 
    CreateForm = "[SettingsForms] POST - Create new form  with current form data", // first time this new form is saved
    UpdateForm = "[SettingsForms] PUT - Update current form", // any update in an existing form

    CreateFields = "[SettingsForms] POST - Create new fields with current fields", // first time a new form is saved
    UpdateFields = "[SettingsForms] PUT - Update current fields", // any field update in an existing form 

    SetActiveForm = "[SettingsForms] - PUT set active property of a form",
	SetActiveFormSuccess = "[SettingsForms] - set active property of a form SUCCESS",
	SetActiveFormError = "[SettingsForms] - set active property of a form ERROR",


    // cleanings
    ClearEditing = "[SettingsForms] - clear current editing form",

}


// Load persisted forms list
export class LoadForms implements Action {
    readonly type = SettingsFormsActionsType.LoadForms;
    constructor() {}
}

export class LoadFormsSuccess implements Action {
    readonly type = SettingsFormsActionsType.LoadFormsSuccess;
    constructor(public forms: Objects.Form[]) {}
}

export class LoadFormsError implements Action {
    readonly type = SettingsFormsActionsType.LoadFormsError;
    constructor(public error: HttpErrorResponse) {}
}

// Load single form to editor
export class LoadForm implements Action {
    readonly type = SettingsFormsActionsType.LoadForm;
    constructor(public formId: string) {}
}

export class LoadFormSuccess implements Action {
    readonly type = SettingsFormsActionsType.LoadFormSuccess;
    constructor(public form: Objects.Form) {}
}

export class LoadFormError implements Action {
    readonly type = SettingsFormsActionsType.LoadFormError;
    constructor() {}
}

// Load fields of a form to editor
export class LoadFields implements Action {
    readonly type = SettingsFormsActionsType.LoadFields;
    constructor(public formId: string) {}
}

export class LoadFieldsSuccess implements Action {
    readonly type = SettingsFormsActionsType.LoadFieldsSuccess;
    constructor(public fields: Array<SettingsCustomFormFieldData>) {}
}

export class LoadFieldsError implements Action {
    readonly type = SettingsFormsActionsType.LoadFieldsError;
    constructor(public error: HttpErrorResponse) {}
}

// syncs
export class SetFormName implements Action {
    readonly type = SettingsFormsActionsType.SetFormName;
    constructor(public name: string) {}
}

export class SetFormDescription implements Action {
    readonly type = SettingsFormsActionsType.SetFormDescription;
    constructor(public description: string) {}
}

export class AddField implements Action {
    readonly type = SettingsFormsActionsType.AddField;
    constructor(public newField: SettingsCustomFormFieldData ) {}
}

export class SetField implements Action {
    readonly type = SettingsFormsActionsType.SetField;
    constructor(public updatedField: SettingsCustomFormFieldData) {}
}

export class MoveFieldUp implements Action {
    readonly type = SettingsFormsActionsType.MoveFieldUp;
    constructor(public field: SettingsCustomFormFieldData ) {}
}
  
export class MoveFieldDown implements Action {
    readonly type = SettingsFormsActionsType.MoveFieldDown;
    constructor(public field: SettingsCustomFormFieldData ) {}
}

export class UpdateFieldPositions implements Action {
    readonly type = SettingsFormsActionsType.UpdateFieldPositions;
    constructor(public fields: Array<SettingsCustomFormFieldData>) {}
}

export class RemoveField implements Action {
    readonly type = SettingsFormsActionsType.RemoveField;
    constructor(public field: SettingsCustomFormFieldData ) {}
}
  
// saves
export class SaveForm implements Action {
    readonly type = SettingsFormsActionsType.SaveForm;
    constructor(public form: Objects.Form) {}
}

export class SaveFormSuccess implements Action {
    readonly type = SettingsFormsActionsType.SaveFormSuccess;
    constructor(public form: Objects.Form, public newForm: boolean = false) {} // param to set true when new form is creted
}

export class SaveFormError implements Action {
    readonly type = SettingsFormsActionsType.SaveFormError;
    constructor(public error: HttpErrorResponse) {}
}

export class SaveFields implements Action {
    readonly type = SettingsFormsActionsType.SaveFields;
    constructor(public newForm: boolean) {}
}

export class SaveFieldsSuccess implements Action {
    readonly type = SettingsFormsActionsType.SaveFieldsSuccess;
    constructor(public fields: Array<SettingsCustomFormFieldData>) {}
}

export class SaveFieldsError implements Action {
    readonly type = SettingsFormsActionsType.SaveFieldsError;
    constructor(public error: HttpErrorResponse) {}
}

// action calls
export class CreateForm implements Action {
    readonly type = SettingsFormsActionsType.CreateForm;
    constructor(public form: Objects.Form) {}
}

export class UpdateForm implements Action {
    readonly type = SettingsFormsActionsType.UpdateForm;
    constructor(public form: Objects.Form) {}
}

export class CreateFields implements Action {
    readonly type = SettingsFormsActionsType.CreateFields;
    constructor(public formId: string, public fields: Array<SettingsCustomFormFieldData>) {}
}

export class UpdateFields implements Action {
    readonly type = SettingsFormsActionsType.UpdateFields;
    constructor(public formId: string, public fields: Array<SettingsCustomFormFieldData>) {}
}

export class SetActiveForm implements Action {
    readonly type = SettingsFormsActionsType.SetActiveForm;
    constructor(public formId: string, public active: boolean) {}
}

export class SetActiveFormSuccess implements Action {
    readonly type = SettingsFormsActionsType.SetActiveFormSuccess;
    constructor(public form: Objects.Form) {}
}

export class SetActiveFormError implements Action {
    readonly type = SettingsFormsActionsType.SetActiveFormError;
    constructor(public error: HttpErrorResponse) {}
}

export class ClearEditing implements Action {
    readonly type = SettingsFormsActionsType.ClearEditing;
    constructor() {}
}

export type SettingsFormsActions = 	LoadForms |
                                    LoadFormsSuccess |
                                    LoadFormsError |
                                    LoadForm |
                                    LoadFormSuccess |
                                    LoadFormError |
                                    LoadFields |
                                    LoadFieldsSuccess |
                                    LoadFieldsError |

                                    SetFormName |
                                    SetFormDescription |
                                    AddField |
                                    SetField |
                                    MoveFieldUp | 
                                    MoveFieldDown |
                                    UpdateFieldPositions |
                                    RemoveField |

                                    SaveForm |
                                    SaveFormSuccess |
                                    SaveFormError |
                                    SaveFields |
                                    SaveFieldsError |
                                    SaveFieldsSuccess |

                                    CreateForm |
                                    UpdateForm |
                                    CreateFields |
                                    UpdateFields |
                                    SetActiveForm |
                                    SetActiveFormSuccess |
                                    SetActiveFormError |

                                    ClearEditing
                                    ;